<template>
  <div class="three-color-scale">
    <div class="three-color-scale__container">
      <div class=three-color-scale__scale-wrapper>
        <div class="three-color-scale__sector three-color-scale__scale"></div>
        <div class="three-color-scale__sector three-color-scale__sector_red"></div>
        <div class="three-color-scale__sector three-color-scale__sector_blue"></div>
        <div class="three-color-scale__inner"></div>
      </div>
      <div class="three-color-scale__arrow-wrapper" :style="style">
        <div class="three-color-scale__arrow-pointer"></div>
        <div class="three-color-scale__arrow-base"></div>
      </div>
    </div>
  </div>
</template>

<script>
 /* eslint-disable no-unused-vars */
import LinkBuildingItem from './LinkBuildingItem'
/**
 * "Speedometer" widget to visualise tf_ratio value. Used in {@link LinkBuildingItem} component
 */
export default {
  name: 'LinkThreeColorScale',
  methods: {},
  props: {
    degree: {
      default: 0
    }
  },
  computed: {
    style () {
      return {
        transform: `rotate(${this.degree}deg)`
      }
    }
  }
}
</script>

<style scoped lang="scss">
  $rfx-scale-size: 18px;
  $rfx-scale-inner-size: 12px;
  .three-color-scale {

    &__container {
      position: relative;
      width: fit-content;
      display: flex;
      justify-content: center;
    }
    &__sector {

      height: #{$rfx-scale-size};
      width: calc(#{$rfx-scale-size} * 2);
      overflow: hidden;
      position: relative;

      &:before {
        height: inherit;
        width: inherit;
        position: absolute;
        content: "";
        border-radius: #{$rfx-scale-size} #{$rfx-scale-size} 0 0;
        background-color: $rfx-red;
        transform-origin: 50% 100%;
        transform: rotate(-140deg);
      }

      &_red {
        position: absolute;
      }

      &_blue {
        position: absolute;

        &:before {
          // @extend .three-color-scale__sector:before;
          background-color: $rfx-red;
          transform: rotate(140deg);
        }
      }
    }

    &__scale {
      position: absolute;
      &:before{
      // @extend .three-color-scale__sector:before;
      background-color: $rfx-green;
      transform: rotate(0deg);
      }
    }

    &__inner {
      height: #{$rfx-scale-inner-size};
      width: calc(#{$rfx-scale-inner-size} * 2);
      overflow: hidden;
      position: relative;

      &:before {
        height: inherit;
        width: inherit;
        position: absolute;
        content: "";
        border-radius: 10px 10px 0 0;
        background-color: white;
        transform-origin: 50% 100%;
        transform: rotate(0deg);
      }
    }

    &__scale-wrapper {
      position: absolute;
      display: flex;
      justify-content: center;
      align-items: flex-end;
      height: #{$rfx-scale-size};
    }

    &__arrow-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 6px;
      transform-origin: 3px 16px;
    }

    &__arrow-pointer {
      width: 0;
      height: 0;
      border-style: solid;
      margin-bottom: -2px;
      border-width: 0 2px 15px 2px;
      border-color: transparent transparent #000 transparent;
    }

    &__arrow-base {
      background-color: #000;
      width: 6px;
      height: 6px;
      border-radius: 50%;
    }
  }

</style>
